export default __webpack_public_path__ + "static/media/icons-background.eebe8a34.png";